export default "https://cdn-static.gokick.com/assets/62cc856e78696df0fd8dcc0a94c6851d482ca838/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";